<div class="wrapper">
  <app-cle-contractor-form
    [data]="data?.contractorDetails"
  />
  <app-actions-section
    [hideLocationOption]="true"
    class="actions-section w-[455px]"
  />
</div>
